import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddressModalComponent } from '../components/address-modal/address-modal.component';
import { AttachmentModalComponent } from '../components/attachment-modal/attachment-modal.component';
import { DriverLocationModalComponent } from '../components/driver-location-modal/driver-location-modal.component';
import { EmailShippingLabelModalComponent } from '../components/email-shipping-label-modal/email-shipping-label-modal.component';
import { EmailParcelDetailsModalComponent } from '../components/email-parcel-details-modal/email-parcel-details-modal.component';
import { EmailRouteShippingLabelsModalComponent } from '../components/email-route-shipping-labels-modal/email-route-shipping-labels-modal.component';
import { EmailRouteStopShippingLabelsModalComponent } from '../components/email-route-stop-shipping-labels-modal/email-route-stop-shipping-labels-modal.component';
import { EmailParcelShippingLabelModalComponent } from '../components/email-parcel-shipping-label-modal/email-parcel-shipping-label-modal.component';
import { PrintRouteTrackingShippingLabelModalComponent } from '../components/print-route-tracking-shipping-label-modal/print-route-tracking-shipping-label-modal.component';
import { LoginModalComponent } from '../components/login-modal/login-modal.component';
import { OrderTemplateModalComponent } from '../components/order-template-modal/order-template-modal.component';
import { PersistInfoModalComponent } from '../components/persist-info-modal/persist-info-modal.component';
import { PrintReceiptModalComponent } from '../components/print-receipt-modal/print-receipt-modal.component';
import { SelectPrintLabelModalComponent } from '../components/select-print-shipping-label/select-print-label-modal.component';
import { TrackOrderDetailsModalComponent } from '../components/track-order-details-modal/track-order-details-modal.component';
import { TrackParcelDetailsModalComponent } from '../components/track-parcel-details-modal/track-parcel-details-modal.component';
import { BarcodeTranslationModalComponent } from '../components/barcode-translation-modal/barcode-translation-modal.component';
import { ModalComponent } from '../components/modal/modal.component';
import { BasicEmailModalComponent } from '../components/basic-email-modal/basic-email-modal.component';

@Injectable({
	providedIn: 'root'
})
export class ModalService {

	constructor(private _dialog: MatDialog) {
	}

	displayAddressModal(address, user, type, warning, name, addresses?, fromAddressBook?, validationResults?, showGooglePlaces?, disableClose?) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';

		// XD-52722: Conditionally disable close (ESC/backdrop) based on caller's enforcement decision
		if (disableClose) {
			dialogConfig.disableClose = true;
		}

		dialogConfig.data = { address, user, type, warning, name, addresses, fromAddressBook, validationResults, showGooglePlaces, enforcementApplies: disableClose };
		return this._dialog.open(AddressModalComponent, dialogConfig);
	}

	displayAttachmentModal(workorder, user, access) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { workorder, user, access };
		return this._dialog.open(AttachmentModalComponent, dialogConfig);
	}

	displayDriverLocationModal(stop, extraData?: any) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.data = { stop, showFullScreen: false, extraData: extraData };
		dialogConfig.panelClass = 'fullscreen-modal-panel';
		return this._dialog.open(DriverLocationModalComponent, dialogConfig);
	}

	displayEmailShippingLabelModal(id, name, showIncludePiecesCheckbox) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { id, name, showIncludePiecesCheckbox };
		return this._dialog.open(EmailShippingLabelModalComponent, dialogConfig);
	}

	displayEmailParcelDetailsModal(id, name, viewType, searchRequestEmail = null, others = null) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { id, name, viewType, searchRequestEmail, others };
		return this._dialog.open(EmailParcelDetailsModalComponent, dialogConfig);
	}

	displayBasicEmailModal(id, name, viewType, searchRequestEmail = null, others = null) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { id, name, viewType, searchRequestEmail, others };
		return this._dialog.open(BasicEmailModalComponent, dialogConfig);
	}

	displayLoginModal(error?) {
		this._dialog.closeAll();
		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = true;
		dialogConfig.data = { error };
		dialogConfig.panelClass = 'fullscreen-modal-panel';
		return this._dialog.open(LoginModalComponent, dialogConfig);
	}

	displayOrderTemplateModal(template, user) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { template, user };
		return this._dialog.open(OrderTemplateModalComponent, dialogConfig);
	}

	displayPersistInfoModal(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = data;
		return this._dialog.open(PersistInfoModalComponent, dialogConfig);
	}

	displayPrintReceiptModal(id, shipmentDetail, shipmentType) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { id, shipmentDetail, shipmentType, mode: 'single' };
		return this._dialog.open(PrintReceiptModalComponent, dialogConfig);
	}

	displayBulkPrintReceiptModal(customerId, beginDate, endDate, quantity, filterField, filterType, filterText) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = {
			reportData: { 
				customerId, 
				beginDate, 
				endDate, 
				quantity,
				filterField, 
				filterType, 
				filterText 
			},
			mode: 'multiple'
		};
		return this._dialog.open(PrintReceiptModalComponent, dialogConfig);
	}

	displayPrintShippingLabelModal(id, showIncludePiecesCheckbox) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { id, showIncludePiecesCheckbox };
		return this._dialog.open(SelectPrintLabelModalComponent, dialogConfig);
	}

	displayTrackingDetails(id, shipmentDetail, shipment) {
		const dialogConfig = new MatDialogConfig();
		let isMobile = window.matchMedia("only screen and (max-width: 480px)").matches;
		if (isMobile) {
			dialogConfig.width = '98vw';
			dialogConfig.height = 'calc(100vh - 50px)';
			dialogConfig.maxWidth = 'unset';
		} else {
			dialogConfig.width = '60vw';
			dialogConfig.height = 'calc(100vh - 30px)';
		}
		dialogConfig.autoFocus = false;
		dialogConfig.data = { id, shipmentDetail, shipment };
		return this._dialog.open(TrackOrderDetailsModalComponent, dialogConfig);
	}

	displayParcelTrackingDetails(id, parcelDetail) {
		const dialogConfig = new MatDialogConfig();
		let isMobile = window.matchMedia("only screen and (max-width: 480px)").matches;
		if (isMobile) {
			dialogConfig.width = '98vw';
			dialogConfig.height = 'calc(100vh - 50px)';
			dialogConfig.maxWidth = 'unset';
		} else {
			dialogConfig.width = '55vw';
		}
		dialogConfig.autoFocus = false;
		dialogConfig.data = { id, parcelDetail };
		return this._dialog.open(TrackParcelDetailsModalComponent, dialogConfig);
	}

	displayBarcodeTranslationModal(barcodeTranslationConfig, orderIsDirty, customer) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { barcodeTranslationConfig, orderIsDirty, customer };
		return this._dialog.open(BarcodeTranslationModalComponent, dialogConfig);
	}

	warningModal(data?: { title?: string, message: string }, styles?: any) {
		return this._dialog.open(ModalComponent,
			{
				data: {
					title: 'Warning!',
					message: ``,
					showCancel: false,
					okText: 'Ok',
					...data
				},
				...styles
			}
		);
	}

	displayEmailRouteShippingLabelsModal(routeId: string, postDate: string) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { routeId, postDate };
		return this._dialog.open(EmailRouteShippingLabelsModalComponent, dialogConfig);
	}

	displayEmailRouteStopShippingLabelsModal(routeId: string, routeStopId: string, subject: string, message: string, defaultEmails: string[] = []) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { routeId, routeStopId, subject, message, defaultEmails };
		return this._dialog.open(EmailRouteStopShippingLabelsModalComponent, dialogConfig);
	}

	displayEmailParcelShippingLabelModal(parcelId: number, subject: string, message: string) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { parcelId, subject, message };
		return this._dialog.open(EmailParcelShippingLabelModalComponent, dialogConfig);
	}

	displayBulkPrintOrderShippingLabelsModal(reportData: {
		customerId: string;
		beginDate: string | null;
		endDate: string | null;
		quantity: number;
		filterField: string | null;
		filterType: string | null;
		filterText: string | null;
	}) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '400px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { mode: 'bulkOrders', reportData };
		return this._dialog.open(PrintRouteTrackingShippingLabelModalComponent, dialogConfig);
	}

	displayBulkEmailOrderShippingLabelsModal(reportData: {
		customerId: string;
		beginDate: string | null;
		endDate: string | null;
		quantity: number;
		filterField: string | null;
		filterType: string | null;
		filterText: string | null;
	}) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '600px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { mode: 'bulkOrders', reportData };
		return this._dialog.open(EmailRouteShippingLabelsModalComponent, dialogConfig);
	}

	displayPrintRouteShippingLabelsModal(routeId: string, postDate: string) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '400px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { mode: 'route', routeId, postDate };
		return this._dialog.open(PrintRouteTrackingShippingLabelModalComponent, dialogConfig);
	}

	displayPrintRouteStopShippingLabelsModal(routeStopId: string) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '400px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { mode: 'routeStop', routeStopId };
		return this._dialog.open(PrintRouteTrackingShippingLabelModalComponent, dialogConfig);
	}

	displayPrintParcelShippingLabelModal(parcelId: number) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = false;
		dialogConfig.width = '400px';
		dialogConfig.maxWidth = '100vw';
		dialogConfig.data = { mode: 'parcel', parcelId };
		return this._dialog.open(PrintRouteTrackingShippingLabelModalComponent, dialogConfig);
	}
}
